import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { formatApiError } from "@/lib/api";
import { Brand, TopControls } from "@/components/Nav";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Auth() {
  const { t, lang, login } = useApp();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const expired = params.get("expired") === "1";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const L = (it, en) => (lang === "en" ? en : it);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); nav("/dashboard"); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1718030463382-896949a8d53a" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/40 mix-blend-multiply" />
      </div>
      <div className="flex flex-col justify-center px-8 sm:px-16 py-12 relative">
        <div className="absolute top-6 right-6"><TopControls /></div>
        <div className="mb-10"><Brand onClick={() => nav("/")} /></div>
        <h1 className="text-3xl font-bold mb-2">{L("Accedi", "Sign in")}</h1>
        <p className="text-muted-foreground mb-8">{t("tagline")}</p>
        {expired && (
          <div data-testid="session-expired-notice" className="max-w-sm mb-6 rounded-md border border-amber-300 bg-amber-50 text-amber-800 px-4 py-3 text-sm dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-300">
            {t("sessionExpired")}
          </div>
        )}
        <form onSubmit={submit} className="space-y-5 max-w-sm">
          <div><Label>{t("email")}</Label>
            <Input data-testid="auth-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" /></div>
          <div><Label>{t("password")}</Label>
            <Input data-testid="auth-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" />
            <div className="mt-1.5 text-right">
              <Link data-testid="auth-forgot-link" to="/forgot-password" className="text-sm text-primary hover:underline">{L("Password dimenticata?", "Forgot password?")}</Link>
            </div>
          </div>
          {err && <p data-testid="auth-error" className="text-sm text-destructive">{err}</p>}
          <Button data-testid="auth-submit" type="submit" className="w-full" disabled={busy}>
            {busy ? t("loading") : L("Accedi", "Sign in")}
          </Button>
        </form>

        <div className="max-w-sm mt-8 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground mb-2">{L("Non hai un account?", "Don't have an account?")}</p>
          <Link data-testid="request-access-link" to="/request-access"
            className="inline-flex items-center justify-center w-full border border-primary/40 text-primary rounded-md py-2.5 text-sm font-semibold hover:bg-primary/5 transition-colors">
            {L("Richiedi accesso", "Request access")}
          </Link>
        </div>
      </div>
    </div>
  );
}
